(function () {
  var style = document.createElement('style');
  style.textContent =
    '@keyframes collCardFadeIn{' +
    'from{opacity:0;transform:translateY(12px)}' +
    'to{opacity:1;transform:translateY(0)}}' +
    '.load-more-btn{' +
    'display:block;margin:30px auto;padding:14px 48px;' +
    'font-family:Yantramanav,sans-serif;font-size:14px;font-weight:500;' +
    'letter-spacing:1.5px;text-transform:uppercase;background:none;' +
    'border:1px solid #3C2216;color:#3C2216;cursor:pointer;}' +
    '.load-more-btn:hover{background:#3C2216;color:#fff;}' +
    '.load-more-btn.is-loading{opacity:.6;pointer-events:none;}';
  document.head.appendChild(style);

  var grid = null;
  var pagination = null;
  var spinner = null;
  var sentinel = null;
  var btn = null;

  var nextUrl = null;
  var loading = false;
  var lastSignature = '';
  var initTimer = null;
  var totalProducts = 0;
  var currentPage = 1;
  var totalPages = 1;
  var observerBound = false;
  var filterEventsBound = false;
  var mutationObserver = null;
  var suspendObserverRefresh = false;
  var lastLoadAttemptAt = 0;
  var clickCooldownMs = 1800;
  var retryDelayMs = 3000;

  function getElements() {
    grid = document.getElementById('product-grid');
    pagination = document.getElementById('infinite-scroll-pagination');
    spinner = document.getElementById('infinite-scroll-spinner');
    sentinel = document.getElementById('infinite-scroll-sentinel');
  }

  function parseNumber(str) {
    var matches = String(str || '').match(/\d+/g);
    if (!matches || !matches.length) return 0;
    return parseInt(matches[0], 10) || 0;
  }

  function getProductKey(el) {
    if (!el || el.nodeType !== 1) return '';

    return (
      el.getAttribute('data-card-key') ||
      el.getAttribute('data-variant-id') ||
      el.getAttribute('data-product-id') ||
      el.getAttribute('data-product-handle') ||
      el.id ||
      (el.querySelector('a[href*="/products/"]') &&
        el.querySelector('a[href*="/products/"]').getAttribute('href')) ||
      ''
    );
  }

  function getExistingKeys() {
    var map = {};
    if (!grid) return map;

    Array.from(grid.children).forEach(function (item) {
      if (!item || !item.tagName || item.tagName.toLowerCase() !== 'li') return;
      var key = getProductKey(item);
      if (key) map[key] = true;
    });

    return map;
  }

  function getLoadedCount() {
    if (!grid) return 0;

    return Array.from(grid.children).filter(function (el) {
      return el.tagName && el.tagName.toLowerCase() === 'li';
    }).length;
  }

  function detectTotalProducts() {
    if (pagination) {
      var explicitCount = pagination.getAttribute('data-products-count');
      var explicitAllCount = pagination.getAttribute('data-all-products-count');

      var productsCount = parseInt(explicitCount || '0', 10);
      var allProductsCount = parseInt(explicitAllCount || '0', 10);

      if (productsCount > 0) return productsCount;
      if (allProductsCount > 0) return allProductsCount;
    }

    var desktopCount = document.getElementById('ProductCountDesktop');
    if (desktopCount) {
      var text = desktopCount.textContent || '';
      var matches = text.match(/\d+/g);
      if (matches && matches.length) {
        return parseInt(matches[0], 10) || 0;
      }
    }

    return 0;
  }

  function detectCurrentPage() {
    if (!pagination) return 1;
    return parseInt(pagination.getAttribute('data-current-page') || '1', 10) || 1;
  }

  function detectTotalPages() {
    if (!pagination) return 1;
    return parseInt(pagination.getAttribute('data-total-pages') || '1', 10) || 1;
  }

  function logCounts(label) {
    console.log('[Load More]', label, {
      loaded: getLoadedCount(),
      totalProducts: totalProducts,
      currentPage: currentPage,
      totalPages: totalPages,
      nextUrl: nextUrl
    });
  }

  function removeExistingButton() {
    var oldBtn = document.getElementById('load-more-btn');
    if (oldBtn) oldBtn.remove();
    btn = null;
  }

  function createButton() {
    removeExistingButton();

    if (!grid) return;

    btn = document.createElement('button');
    btn.id = 'load-more-btn';
    btn.className = 'load-more-btn';
    btn.type = 'button';
    btn.textContent = 'Load More';

    btn.addEventListener('click', function () {
      var now = Date.now();

      if (loading) return;

      if (now - lastLoadAttemptAt < clickCooldownMs) {
        btn.textContent = 'Please wait...';
        btn.disabled = true;

        setTimeout(function () {
          if (!btn || loading) return;
          btn.disabled = false;
          btn.textContent = 'Load More';
        }, Math.max(800, clickCooldownMs - (now - lastLoadAttemptAt)));

        return;
      }

      lastLoadAttemptAt = now;
      loadNextPage(true, 0);
    });

    var gridParent = grid.closest('.collection') || grid.parentElement;
    if (gridParent && gridParent.parentElement) {
      gridParent.parentElement.insertBefore(btn, gridParent.nextSibling);
    }
  }

  function shouldHideButton() {
    var loaded = getLoadedCount();

    if (totalProducts > 0 && loaded >= totalProducts) {
      return true;
    }

    if (currentPage >= totalPages && totalPages > 1 && (!nextUrl || nextUrl === 'null')) {
      return true;
    }

    if (!nextUrl && totalProducts === 0 && totalPages <= 1) {
      return true;
    }

    return false;
  }

  function updateButton() {
    if (!btn) return;

    if (shouldHideButton()) {
      btn.style.display = 'none';
      logCounts('hide button');
      return;
    }

    btn.style.display = 'block';

    if (!loading) {
      btn.textContent = 'Load More';
      btn.classList.remove('is-loading');
      btn.disabled = false;
    }

    logCounts('show button');
  }

  function buildRequestUrl(url) {
    var sectionId = grid && grid.dataset ? (grid.dataset.id || '') : '';
    if (!sectionId) return url;
    if (url.indexOf('section_id=') !== -1) return url;

    return url + (url.indexOf('?') !== -1 ? '&' : '?') + 'section_id=' + encodeURIComponent(sectionId);
  }

  function extractItems(doc) {
    var newGrid = doc.getElementById('product-grid');
    if (!newGrid) return [];

    return Array.from(newGrid.children).filter(function (el) {
      return el.tagName && el.tagName.toLowerCase() === 'li';
    });
  }

  function extractPagination(doc) {
    return doc.getElementById('infinite-scroll-pagination');
  }

  function extractNextUrl(doc) {
    var newPagination = extractPagination(doc);
    if (!newPagination) return null;
    return newPagination.getAttribute('data-next-url') || null;
  }

  function extractTotalProducts(doc) {
    var newPagination = extractPagination(doc);
    if (newPagination) {
      var explicitCount = newPagination.getAttribute('data-products-count');
      var explicitAllCount = newPagination.getAttribute('data-all-products-count');

      var productsCount = parseInt(explicitCount || '0', 10);
      var allProductsCount = parseInt(explicitAllCount || '0', 10);

      if (productsCount > 0) return productsCount;
      if (allProductsCount > 0) return allProductsCount;
    }

    var desktopCount = doc.getElementById('ProductCountDesktop');
    if (desktopCount) {
      var text = desktopCount.textContent || '';
      var matches = text.match(/\d+/g);
      if (matches && matches.length) {
        return parseInt(matches[0], 10) || 0;
      }
    }

    return 0;
  }

  function extractCurrentPage(doc) {
    var newPagination = extractPagination(doc);
    if (!newPagination) return 0;
    return parseInt(newPagination.getAttribute('data-current-page') || '0', 10) || 0;
  }

  function extractTotalPages(doc) {
    var newPagination = extractPagination(doc);
    if (!newPagination) return 0;
    return parseInt(newPagination.getAttribute('data-total-pages') || '0', 10) || 0;
  }

  function syncPaginationAttributes(newPagination, newNextUrl, newCurrentPage, newTotalPages, newTotalProducts) {
    if (!pagination) return;

    if (newNextUrl) {
      pagination.setAttribute('data-next-url', newNextUrl);
    } else {
      pagination.removeAttribute('data-next-url');
    }

    if (newCurrentPage > 0) {
      pagination.setAttribute('data-current-page', String(newCurrentPage));
    }

    if (newTotalPages > 0) {
      pagination.setAttribute('data-total-pages', String(newTotalPages));
    }

    if (newTotalProducts > 0) {
      pagination.setAttribute('data-products-count', String(newTotalProducts));
    }

    if (newPagination) {
      var newAllCount = newPagination.getAttribute('data-all-products-count');
      if (newAllCount) {
        pagination.setAttribute('data-all-products-count', newAllCount);
      }
      pagination.innerHTML = newPagination.innerHTML;
    }
  }

  function setLoadingState() {
    loading = true;
    if (btn) {
      btn.textContent = 'Loading...';
      btn.classList.add('is-loading');
      btn.disabled = true;
    }
  }

  function clearLoadingState() {
    loading = false;
    if (btn) {
      btn.classList.remove('is-loading');
      btn.disabled = false;
    }
  }

  function appendItems(items, animate, existingKeys) {
    var appendedCount = 0;

    suspendObserverRefresh = true;

    items.forEach(function (item, i) {
      var key = getProductKey(item);

      if (key && existingKeys[key]) return;
      if (key) existingKeys[key] = true;

      item.classList.add('scroll-trigger--cancel');

      if (animate) {
        item.style.opacity = '0';
        item.style.animation = 'collCardFadeIn 0.4s ease forwards';
        item.style.animationDelay = (i * 0.06) + 's';
      }

      grid.appendChild(item);
      appendedCount++;
    });

    setTimeout(function () {
      suspendObserverRefresh = false;
    }, 250);

    return appendedCount;
  }

  function handleRateLimit(previousNextUrl, retryCount) {
    nextUrl = previousNextUrl;
    clearLoadingState();

    if (pagination && nextUrl) {
      pagination.setAttribute('data-next-url', nextUrl);
    }

    if (!btn) return;

    btn.style.display = 'block';

    if (retryCount < 1) {
      btn.textContent = 'Retrying...';
      btn.disabled = true;

      setTimeout(function () {
        if (!btn || loading || !nextUrl) return;
        lastLoadAttemptAt = Date.now();
        loadNextPage(true, retryCount + 1);
      }, retryDelayMs);
    } else {
      btn.textContent = 'Try Again';
      btn.disabled = true;

      setTimeout(function () {
        if (!btn) return;
        btn.disabled = false;
        btn.textContent = 'Load More';
      }, retryDelayMs);
    }
  }

  function loadNextPage(animate, retryCount) {
    if (loading || !nextUrl || !grid) return;

    retryCount = retryCount || 0;

    var requestUrl = nextUrl;
    var previousNextUrl = nextUrl;

    setLoadingState();
    logCounts('before fetch');

    var existingKeys = getExistingKeys();

    fetch(buildRequestUrl(requestUrl), { credentials: 'same-origin' })
      .then(function (res) {
        if (!res.ok) {
          var error = new Error('HTTP ' + res.status);
          error.status = res.status;
          throw error;
        }
        return res.text();
      })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var items = extractItems(doc);
        var newPagination = extractPagination(doc);
        var fetchedNextUrl = extractNextUrl(doc);
        var fetchedTotal = extractTotalProducts(doc);
        var fetchedCurrentPage = extractCurrentPage(doc);
        var fetchedTotalPages = extractTotalPages(doc);

        if (fetchedTotal > 0) totalProducts = fetchedTotal;
        if (fetchedCurrentPage > 0) currentPage = fetchedCurrentPage;
        else currentPage = currentPage + 1;
        if (fetchedTotalPages > 0) totalPages = fetchedTotalPages;

        var appendedCount = appendItems(items, animate, existingKeys);

        if (appendedCount > 0) {
          nextUrl = fetchedNextUrl || null;
        } else {
          if (fetchedNextUrl && fetchedNextUrl !== previousNextUrl) {
            nextUrl = fetchedNextUrl;
          } else if (currentPage < totalPages) {
            nextUrl = previousNextUrl;
          } else {
            nextUrl = null;
          }
        }

        syncPaginationAttributes(
          newPagination,
          nextUrl,
          currentPage,
          totalPages,
          totalProducts
        );

        if (typeof FacetFiltersForm !== 'undefined' && FacetFiltersForm.filterByVariantAvailability) {
          FacetFiltersForm.filterByVariantAvailability();
        }

        clearLoadingState();

        console.log('[Load More] fetch result', {
          appendedCount: appendedCount,
          loaded: getLoadedCount(),
          totalProducts: totalProducts,
          currentPage: currentPage,
          totalPages: totalPages,
          nextUrl: nextUrl
        });

        updateButton();
      })
      .catch(function (err) {
        console.error('[Load More] fetch failed:', err);

        if (err && err.status === 429) {
          handleRateLimit(previousNextUrl, retryCount);
          return;
        }

        nextUrl = previousNextUrl;
        clearLoadingState();

        if (pagination && nextUrl) {
          pagination.setAttribute('data-next-url', nextUrl);
        }

        if (btn) {
          btn.style.display = 'block';
          btn.textContent = 'Load More';
        }
      });
  }

  function getSignature() {
    var gridId = grid ? (grid.dataset.id || '') : '';
    var paginationNext = pagination ? (pagination.getAttribute('data-next-url') || '') : '';
    var count = getLoadedCount();
    var total = detectTotalProducts();
    var page = detectCurrentPage();
    var pages = detectTotalPages();

    return [gridId, paginationNext, count, total, page, pages].join('||');
  }

  function setupLoadMore(force) {
    getElements();

    if (!grid) {
      removeExistingButton();
      return;
    }

    if (spinner) spinner.style.display = 'none';
    if (sentinel) sentinel.style.display = 'none';

    totalProducts = detectTotalProducts();
    currentPage = detectCurrentPage();
    totalPages = detectTotalPages();
    nextUrl = pagination ? (pagination.getAttribute('data-next-url') || null) : null;

    var sig = getSignature();
    if (!force && sig === lastSignature && btn) {
      updateButton();
      return;
    }

    createButton();
    lastSignature = sig;
    loading = false;

    console.log('[Load More] setup', {
      loaded: getLoadedCount(),
      totalProducts: totalProducts,
      currentPage: currentPage,
      totalPages: totalPages,
      nextUrl: nextUrl
    });

    updateButton();
  }

  function scheduleSetup(force) {
    if (suspendObserverRefresh) return;

    clearTimeout(initTimer);
    initTimer = setTimeout(function () {
      setupLoadMore(force);
    }, 150);
  }

  function bindObserver() {
    if (observerBound) return;
    observerBound = true;

    var container = document.getElementById('ProductGridContainer') || document.body;
    if (!container) return;

    mutationObserver = new MutationObserver(function (mutations) {
      if (suspendObserverRefresh) return;

      var refresh = false;

      mutations.forEach(function (mutation) {
        if (mutation.type !== 'childList') return;

        Array.from(mutation.addedNodes).forEach(function (node) {
          if (!node || node.nodeType !== 1) return;

          if (
            node.id === 'product-grid' ||
            node.id === 'infinite-scroll-pagination' ||
            node.id === 'ProductGridContainer' ||
            (node.querySelector &&
              (node.querySelector('#product-grid') ||
                node.querySelector('#infinite-scroll-pagination')))
          ) {
            refresh = true;
          }
        });

        Array.from(mutation.removedNodes).forEach(function (node) {
          if (!node || node.nodeType !== 1) return;

          if (
            node.id === 'product-grid' ||
            node.id === 'infinite-scroll-pagination' ||
            (node.querySelector &&
              (node.querySelector('#product-grid') ||
                node.querySelector('#infinite-scroll-pagination')))
          ) {
            refresh = true;
          }
        });
      });

      if (refresh) scheduleSetup(true);
    });

    mutationObserver.observe(container, {
      childList: true,
      subtree: true
    });
  }

  function bindFilterEvents() {
    if (filterEventsBound) return;
    filterEventsBound = true;

    document.addEventListener('change', function (e) {
      var target = e.target;
      if (!target) return;

      if (
        target.closest('facet-filters-form') ||
        target.closest('price-range') ||
        target.matches('input[name*="filter."], select[name*="filter."]') ||
        target.matches('#SortBy')
      ) {
        scheduleSetup(true);
      }
    });

    document.addEventListener('click', function (e) {
      var target = e.target.closest('a, button');
      if (!target) return;

      if (
        target.closest('facet-filters-form') ||
        target.matches('[data-reset], .active-facets__button, .facets__reset')
      ) {
        scheduleSetup(true);
      }
    });

    window.addEventListener('popstate', function () {
      scheduleSetup(true);
    });
  }

  function init() {
    setupLoadMore(true);
    bindObserver();
    bindFilterEvents();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();